import { UserTracking, GlobalTracking } from '@sdui-hq/tracking'
import { getSegmentation, getCurrentRoute, getSchoolSegmentation } from './utils.js'
export * from './constants.js'

const getReleaseName = () => {
  return `${import.meta.env.VITE_VERSION_TYPE} (${import.meta.env.GIT_HASH})`
}

const tracking = new UserTracking({
  app_key: import.meta.env.VITE_COUNTLY_KEY,
  app_version: getReleaseName(),
  url: import.meta.env.VITE_COUNTLY_URL,
  debug: import.meta.env.VITE_COUNTLY_DEBUG
},
getSegmentation,
getCurrentRoute
)

const globalTracking = new GlobalTracking({
  app_key: import.meta.env.VITE_SCHOOL_COUNTLY_KEY,
  app_version: getReleaseName(),
  url: import.meta.env.VITE_COUNTLY_URL,
  debug: import.meta.env.VITE_COUNTLY_DEBUG
},
getSchoolSegmentation
)

// Object.freeze(globalTracking)
export { globalTracking }

export default tracking
